// Add your JS customizations here
jQuery(document).ready(function($) {


	$('.gallrey-slider').slick({
		slidesToShow: 1,
		infinite:true,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 2000,
		dots: false,
		arrows: true
	});

	var paginationLinks = document.querySelectorAll('.custom-pagination a');

	// Iterate over each pagination link
	paginationLinks.forEach(function(link) {
		// If the link has the 'inactive' class
		if (link.classList.contains('inactive')) {
			// Disable the link
			link.addEventListener('click', function(event) {
				event.preventDefault(); // Prevent the default click action
			});
		}
	});

	var paginationLinks2 = document.querySelectorAll('.custom-pagination-other a');

	// Iterate over each pagination link
	paginationLinks2.forEach(function(link) {
		// If the link has the 'inactive' class
		if (link.classList.contains('inactive')) {
			// Disable the link
			link.addEventListener('click', function(event) {
				event.preventDefault(); // Prevent the default click action
			});
		}
	});

	if ($(window).width() > 991) {
		// Get the button element
		var buttonBook = document.querySelector('.booking-tab .button.book');

		// Get the content element
		var contentBook = document.querySelector('.booking-tab .content');

		// Set the height of the button equal to the height of the content
		buttonBook.style.width = contentBook.clientHeight + 3 + 'px';
	} else {
		var buttonBook = document.querySelector('.booking-tab .button.book');

		buttonBook.style.width = 'auto';
	}

	function moveBookingTab() {
		if ($(window).width() < 991) {
			var contentWidth = $('.booking-tab .content').outerHeight(); // Calculate the width of .content
			var buttonHeight = $('.booking-tab .button').outerHeight();

			// Move .booking-tab to the right by the width of .content
			$('.booking-tab').css('bottom', -(contentWidth - buttonHeight/2) + 'px');

			// Toggle class 'moved' when .book is clicked
			$('.booking-tab .book').on('click', function(e) {
				e.preventDefault();
				$('.booking-tab').toggleClass('moved');
			});
		}
		else {
			var contentWidth = $('.booking-tab .content').outerWidth(); // Calculate the width of .content
			var buttonHeight = $('.booking-tab .button').outerHeight();

			// Move .booking-tab to the right by the width of .content
			$('.booking-tab').css('right', -(contentWidth - buttonHeight/2) + 'px');

			// Toggle class 'moved' when .book is clicked
			$('.booking-tab .book').on('click', function(e) {
				e.preventDefault();
				$('.booking-tab').toggleClass('moved');
			});
		}
	}

	setInterval(function () {
		moveBookingTab();

		if ($(window).width() > 991) {
			// Get the button element
			var buttonBook = document.querySelector('.booking-tab .button.book');

			// Get the content element
			var contentBook = document.querySelector('.booking-tab .content');

			// Set the height of the button equal to the height of the content
			buttonBook.style.width = contentBook.clientHeight + 3 + 'px';
		} else {
			var buttonBook = document.querySelector('.booking-tab .button.book');

			buttonBook.style.width = 'auto';
		}
	}, 300);

	// Call the function on page load
	moveBookingTab();

	$(window).on('resize', function() {
		function moveBookingTab() {
			if ($(window).width() < 991) {
				var contentWidth = $('.booking-tab .content').outerHeight(); // Calculate the width of .content
				var buttonHeight = $('.booking-tab .button').outerHeight();

				// Move .booking-tab to the right by the width of .content
				$('.booking-tab').css('bottom', -(contentWidth - buttonHeight/2) + 'px');

				// Toggle class 'moved' when .book is clicked
				$('.booking-tab .book').on('click', function(e) {
					e.preventDefault();
					$('.booking-tab').toggleClass('moved');
				});
			}
			else {
				var contentWidth = $('.booking-tab .content').outerWidth(); // Calculate the width of .content
				var buttonHeight = $('.booking-tab .button').outerHeight();

				// Move .booking-tab to the right by the width of .content
				$('.booking-tab').css('right', -(contentWidth - buttonHeight/2) + 'px');

				// Toggle class 'moved' when .book is clicked
				$('.booking-tab .book').on('click', function(e) {
					e.preventDefault();
					$('.booking-tab').toggleClass('moved');
				});
			}
		}

		// Call the function on page load
		moveBookingTab();

		if ($(window).width() < 991) {
			$('.post-bottom .prev-link').html('Previous');
			$('.post-bottom .next-link').html('Next');

			var buttonBook = document.querySelector('.booking-tab .button.book');

			buttonBook.style.width = 'auto';
		}
		else {
			// Get the button element
			var buttonBook = document.querySelector('.booking-tab .button.book');

			// Get the content element
			var contentBook = document.querySelector('.booking-tab .content');

			// Set the height of the button equal to the height of the content
			buttonBook.style.width = contentBook.clientHeight + 3 + 'px';

			$('.post-bottom .prev-link').html('Previous Post');
			$('.post-bottom .next-link').html('Next Post');
		}
	});

	if ($(window).width() < 991) {
		$('.post-bottom .prev-link').html('Previous');
		$('.post-bottom .next-link').html('Next');
	}
	else {
		$('.post-bottom .prev-link').html('Previous Post');
		$('.post-bottom .next-link').html('Next Post');
	}

	$('.post-content *:has(iframe)').each(function () {

		$(window).on('resize', function() {
			if ($(window).width() < 991) {
				$(this).css({
					'position': 'relative',
					'padding-top': '56.25%',
					'width': '100%',
					'overflow': 'hidden', // Optional: Hide overflowing content
					'display': 'flex',
					'justify-content': 'center',
					'align-self': 'center',
					'margin': '1rem 0 1rem'
				});
			}
			else {
				$(this).css({
					'position': 'relative',
					'padding-top': '56.25%',
					'width': '80%',
					'overflow': 'hidden', // Optional: Hide overflowing content
					'display': 'flex',
					'justify-content': 'center',
					'align-self': 'center',
					'margin': '2rem 0 4rem'
				});
			}
		});

		if ($(window).width() < 991) {
			$(this).css({
				'position': 'relative',
				'padding-top': '56.25%',
				'width': '100%',
				'overflow': 'hidden', // Optional: Hide overflowing content
				'display': 'flex',
				'justify-content': 'center',
				'align-self': 'center',
				'margin': '1rem 0 1rem'
			});
		}
		else {
			$(this).css({
				'position': 'relative',
				'padding-top': '56.25%',
				'width': '80%',
				'overflow': 'hidden', // Optional: Hide overflowing content
				'display': 'flex',
				'justify-content': 'center',
				'align-self': 'center',
				'margin': '2rem 0 4rem'
			});
		}

	});

	$('.post-content *:has(img)').each(function () {

		$(window).on('resize', function() {
			if ($(window).width() < 991) {
				$(this).css({
					'position': 'relative',
					'width': '100%',
					'display': 'flex',
					'justify-content': 'center',
					'align-self': 'center',
					'margin': '1rem 0 1rem'
				});
			}
			else {
				$(this).css({
					'position': 'relative',
					'width': '80%',
					'display': 'flex',
					'justify-content': 'center',
					'align-self': 'center',
					'margin': '2rem 0 4rem'
				});
			}
		});

		if ($(window).width() < 991) {
			$(this).css({
				'position': 'relative',
				'width': '100%',
				'display': 'flex',
				'justify-content': 'center',
				'align-self': 'center',
				'margin': '1rem 0 1rem'
			});
		}
		else {
			$(this).css({
				'position': 'relative',
				'width': '80%',
				'display': 'flex',
				'justify-content': 'center',
				'align-self': 'center',
				'margin': '2rem 0 4rem'
			});
		}

	});

	$(".treatments-dropdown-wrapper select").select2({
		dropdownCssClass: 'treatments-dropdown-class',
		// placeholder: "Select your issue"
	});

	$('.treatments-dropdown').on('select2:select', function (e) {
		// console.log('Option selected:', e);
		var link = e.params.data.id;
		if (link) {
			window.location.href = link;
		}
	});

	$('.treatments-dropdown-wrapper .select2-selection__arrow').html('<svg id="triangle" xmlns="http://www.w3.org/2000/svg" width="7.0556mm" height="3.5278mm" viewBox="0 0 20 10"><defs><style>.cls-1{fill:#b39859;stroke-width:0px;}</style></defs><polygon class="cls-1" points="0 0 10 10 20 0 0 0"/></svg>\n');

	$('.treatments-dropdown-class .select2-selection__arrow').html('<svg id="triangle" xmlns="http://www.w3.org/2000/svg" width="7.0556mm" height="3.5278mm" viewBox="0 0 20 10"><defs><style>.cls-1{fill:#b39859;stroke-width:0px;}</style></defs><polygon class="cls-1" points="0 0 10 10 20 0 0 0"/></svg>\n');

	$('#main-nav .nav-menu-button').on('click', function (e) {
		e.preventDefault();

		if($('.nav-main-menu').hasClass('active')) {
			$('.nav-main-menu').removeClass('active');
			$('.nav-main-menu').addClass('inactive');
			$('.sub-menu-button').removeClass('active');

			$('.hero-home .background').css('background', 'rgba(0,0,0, .4)');
		} else {
			$('.nav-main-menu').addClass('active');
			$('.nav-main-menu').removeClass('inactive');

			$('.hero-home .background').css('background', 'rgba(0,0,0, .6)');
		}

		$('#main-nav .nav-menu-button').toggleClass('active');

		if($('#main-nav .nav-menu-button').hasClass('active')) {
			$('#main-nav .nav-menu-button .menu').html('Close');
			$('#main-nav .nav-menu-button .open').html('Close');
		} else {
			$('#main-nav .nav-menu-button .menu').html('Menu');
			$('#main-nav .nav-menu-button .open').html('Open');
		}

		if($('.treatments-menu').hasClass('active')) {
			$('.treatments-menu').removeClass('active');
		}

		//Clinic Menu
		if ($('.clinic-menu').hasClass('active')) {
			$('.clinic-menu').removeClass('active');
		}

		if($('.conditions-menu').hasClass('active')) {
			$('.conditions-menu').removeClass('active');
		}

		if($('.about-menu').hasClass('active')) {
			$('.about-menu').removeClass('active');
		}
	});

	if ($(window).width() > 991) {
		$('.ti-widget-container').removeClass('ti-col-4');
		$('.ti-widget-container').removeClass('ti-col-5');
		$('.ti-widget-container').removeClass('ti-col-6');
		$('.ti-widget-container').removeClass('ti-col-7');

		$('.ti-widget-container').addClass('ti-col-3');
	} else {
		$('.ti-widget-container').removeClass('ti-col-3');
		$('.ti-widget-container').removeClass('ti-col-5');
		$('.ti-widget-container').removeClass('ti-col-2');
		$('.ti-widget-container').removeClass('ti-col-4');

		$('.ti-widget-container').addClass('ti-col-1');

		if($('.fee-breakdowns-block .fee-breakdowns-top.mobile').length > 0) {
			$('.fee-breakdowns-block .fee-breakdowns-top.mobile').slick({
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
					arrows: false,
					dots: true,
					autoplay: false,
					centerMode: false,
					variableWidth: false,
				},
				responsive: [
					{
						breakpoint: 9999,
						settings: "unslick"
					},
					{
						breakpoint: 991,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							infinite: true,
							arrows: false,
							dots: true,
							autoplay: false,
							centerMode: false,
							variableWidth: false,
						}
					}
				]
			});
		}

		
			
		
	}

	

	// $('.ti-widget .ti-star.f').html('<i class="fa-sharp fa-solid fa-star-sharp"></i>');
	// $('.ti-widget .ti-star.e').html('<i className="fa-light fa-star-sharp"></i>');

	setInterval(() => {
		if ($(window).width() > 991) {
			$('.ti-widget-container').removeClass('ti-col-4');
			$('.ti-widget-container').removeClass('ti-col-5');

			$('.ti-widget-container').addClass('ti-col-3');
		} else {
			$('.ti-widget-container').removeClass('ti-col-3');
			$('.ti-widget-container').removeClass('ti-col-5');
			$('.ti-widget-container').removeClass('ti-col-2');
			$('.ti-widget-container').removeClass('ti-col-4');

			$('.ti-widget-container').addClass('ti-col-1');
		}
	}, 300);

	$('.nav-main-menu a').addClass('font-2-nav upper');

	$('.footer-menu a').addClass('font-8-other upper');

	/* Clinic Trigger Start */
	$('.clinic-trigger').on('click', function (e) {
	    e.preventDefault();

	    if ($('.clinic-menu').hasClass('active')) {
	      $('.clinic-menu').removeClass('active');
	      $('.sub-menu-button').removeClass('active');
	    } else {
	      $('.clinic-menu').addClass('active');
	      $('.sub-menu-button').addClass('active');
	    }

	    if ($('.about-menu').hasClass('active')) {
	      $('.about-menu').removeClass('active');
	    }

	    if ($('.conditions-menu').hasClass('active')) {
	      $('.conditions-menu').removeClass('active');
	    }
		
		if($('.treatments-menu').hasClass('active')) {
			$('.treatments-menu').removeClass('active');
		}
	  });

	  /* Clinic Trigger End */

	$('.about-trigger').on('click', function(e) {
		e.preventDefault();

		if($('.about-menu').hasClass('active')) {
			$('.about-menu').removeClass('active');
			$('.sub-menu-button').removeClass('active');
		} else {
			$('.about-menu').addClass('active');
			$('.sub-menu-button').addClass('active');
		}

		if($('.treatments-menu').hasClass('active')) {
			$('.treatments-menu').removeClass('active');
		}

		//Clinic Menu
		if ($('.clinic-menu').hasClass('active')) {
			$('.clinic-menu').removeClass('active');
		}

		if($('.conditions-menu').hasClass('active')) {
			$('.conditions-menu').removeClass('active');
		}
	});

	$('.treatments-trigger').on('click', function(e) {
		e.preventDefault();

		if($('.treatments-menu').hasClass('active')) {
			$('.treatments-menu').removeClass('active');
			$('.sub-menu-button').removeClass('active');
		} else {
			$('.treatments-menu').addClass('active');
			$('.sub-menu-button').addClass('active');
		}

		if($('.about-menu').hasClass('active')) {
			$('.about-menu').removeClass('active');
		}

		//Clinic Menu
		if ($('.clinic-menu').hasClass('active')) {
			$('.clinic-menu').removeClass('active');
		}

		if($('.conditions-menu').hasClass('active')) {
			$('.conditions-menu').removeClass('active');
		}
	});

	$('.conditions-trigger').on('click', function(e) {
		e.preventDefault();

		if($('.conditions-menu').hasClass('active')) {
			$('.conditions-menu').removeClass('active');
			$('.sub-menu-button').removeClass('active');
		} else {
			$('.conditions-menu').addClass('active');
			$('.sub-menu-button').addClass('active');
		}

		//Clinic Menu
		if ($('.clinic-menu').hasClass('active')) {
			$('.clinic-menu').removeClass('active');
		}

		if($('.about-menu').hasClass('active')) {
			$('.about-menu').removeClass('active');
		}

		if($('.treatments-menu').hasClass('active')) {
			$('.treatments-menu').removeClass('active');
		}
	});

	$('.sub-menu-button').on('click', function (e) {
		e.preventDefault();

		if($('.about-menu').hasClass('active')) {
			$('.about-menu').removeClass('active');
			$('.sub-menu-button').removeClass('active');
		}

		if($('.treatments-menu').hasClass('active')) {
			$('.treatments-menu').removeClass('active');
			$('.sub-menu-button').removeClass('active');
		}

		if($('.conditions-menu').hasClass('active')) {
			$('.conditions-menu').removeClass('active');
			$('.sub-menu-button').removeClass('active');
		}

		//Clinic Menu
		if ($('.clinic-menu').hasClass('active')) {
			$('.clinic-menu').removeClass('active');
			$('.sub-menu-button').removeClass('active');
		}

	});

	$('.about-menu .menu-button').on('click', function (e) {
		e.preventDefault();

		if($('.about-menu').hasClass('active')) {
			$('.about-menu').removeClass('active');
		} else {
			$('.about-menu').addClass('active');
		}
	});

	$('.treatments-menu .menu-button').on('click', function (e) {
		e.preventDefault();

		if($('.treatments-menu').hasClass('active')) {
			$('.treatments-menu').removeClass('active');
		} else {
			$('.treatments-menu').addClass('active');
		}
	});

	// Clinic Menu Button
	$('.clinic-menu .menu-button').on('click', function (e) {
	    e.preventDefault();

	    if ($('.clinic-menu').hasClass('active')) {
	      $('.clinic-menu').removeClass('active');
	    } else {
	      $('.clinic-menu').addClass('active');
	    }
	  });

	$('.conditions-menu .menu-button').on('click', function (e) {
		e.preventDefault();

		if($('.conditions-menu').hasClass('active')) {
			$('.conditions-menu').removeClass('active');
		} else {
			$('.conditions-menu').addClass('active');
		}
	});

	$('.treatment-trigger').on('click', function (e) {
		e.preventDefault();

		$('.treatments-menu').addClass('active');

		$('.nav-main-menu').addClass('active');

		$('.hero-home .background').css('background', 'rgba(0,0,0, .6)');

		$('#main-nav .nav-menu-button').toggleClass('active');

		if($('#main-nav .nav-menu-button').hasClass('active')) {
			$('#main-nav .nav-menu-button .menu').html('Close');
			$('#main-nav .nav-menu-button .open').html('Close');
		} else {
			$('#main-nav .nav-menu-button .menu').html('Menu');
			$('#main-nav .nav-menu-button .open').html('Open');
		}
	});

	$('.footer-locations .man-trigger').on('click', function (e) {
		e.preventDefault();

		$('.footer-locations .footer-locations-london').removeClass('active');
		$('.footer-locations .lon-trigger').removeClass('active');

		$('.footer-locations .footer-locations-manchester').removeClass('inactive');

		$('.footer-locations .footer-locations-manchester').addClass('active');
		$('.footer-locations .man-trigger').addClass('active');

		$('.footer-locations .footer-locations-london').addClass('inactive');


		$('.footer-locations .footer-locations-london-mobile').removeClass('active');
		$('.footer-locations .lon-trigger').removeClass('active');

		$('.footer-locations .footer-locations-manchester-mobile').removeClass('inactive');

		$('.footer-locations .footer-locations-manchester-mobile').addClass('active');
		$('.footer-locations .man-trigger').addClass('active');

		$('.footer-locations .footer-locations-london-mobile').addClass('inactive');

	});

	$('.footer-locations .lon-trigger').on('click', function (e) {
		e.preventDefault();

		$('.footer-locations .footer-locations-manchester').removeClass('active');
		$('.footer-locations .man-trigger').removeClass('active');

		$('.footer-locations .footer-locations-london').removeClass('inactive');

		$('.footer-locations .footer-locations-london').addClass('active');
		$('.footer-locations .lon-trigger').addClass('active');

		$('.footer-locations .footer-locations-manchester').addClass('inactive');


		$('.footer-locations .footer-locations-manchester-mobile').removeClass('active');
		$('.footer-locations .man-trigger').removeClass('active');

		$('.footer-locations .footer-locations-london-mobile').removeClass('inactive');

		$('.footer-locations .footer-locations-london-mobile').addClass('active');
		$('.footer-locations .lon-trigger').addClass('active');

		$('.footer-locations .footer-locations-manchester-mobile').addClass('inactive');

	});

	$('.faq-block .questions .question').click(function () {
		var index = $(this).index();
		$('.faq-block .questions .question').removeClass('active');
		$('.faq-block .answers .answer').removeClass('active');
		$(this).addClass('active');
		$('.faq-block .answers .answer.item-' + index).addClass('active');
	});

	$('.covered-block .questions .question').click(function () {
		var index = $(this).index();
		$('.covered-block .questions .question').removeClass('active');
		$('.covered-block .answers .answer').removeClass('active');
		$(this).addClass('active');
		$('.covered-block .answers .answer.item-' + index).addClass('active');
	});

	$('.fee-plans-block .fee-plans .item').click(function () {
		var index = $(this).index();
		$('.fee-plans-block .fee-plans .item').removeClass('active');
		$(this).addClass('active');
		$('.fee-plans-block .fee-plans .item.item-' + index).addClass('active');

		if(index == 0) {
			$('.fee-plans-block .fee-plans').css('left', '-11%');
		}

		if(index == 1) {
			$('.fee-plans-block .fee-plans').css('left', '0');
		}

		if(index == 2) {
			$('.fee-plans-block .fee-plans').css('left', '11%');
		}
	});

	$('.loyalty-plans-block .loyalty-plans .item').click(function () {
		var index = $(this).index();
		$('.loyalty-plans-block .loyalty-plans .item').removeClass('active');
		$(this).addClass('active');
		$('.layalty-plans-block .loyalty-plans .item.item-' + index).addClass('active');

		if(index == 0) {
			$('.loyalty-plans-block .loyalty-plans').css('left', '-11%');
		}

		if(index == 1) {
			$('.loyalty-plans-block .loyalty-plans').css('left', '0');
		}

		if(index == 2) {
			$('.loyalty-plans-block .loyalty-plans').css('left', '11%');
		}
	});


	if($('.hero-home').length > 0) {
		$('.hero-home').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			arrows: false,
			dots: false,
			autoplay: true,
			centerMode: false,
			variableWidth: false,
			autoplaySpeed: 3400,
			speed: 900,
			cssEase: 'ease-in',
			fade: true
		});
	}

	if($('.treatments-block').length > 0) {
		$('.treatments-block .left').slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			infinite: true,
			arrows: false,
			dots: false,
			autoplay: false,
			centerMode: false,
			variableWidth: false,
			responsive: [
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						infinite: true,
						arrows: false,
						dots: false,
						autoplay: false,
						centerMode: false,
						variableWidth: false,
					}
				}
			]
		});
	}

	if($('.pricing-block-paragraphs .content.mobile').length > 0) {
		$('.pricing-block-paragraphs .content.mobile').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			arrows: true,
			dots: true,
			autoplay: false,
			centerMode: false,
			variableWidth: false,
		});
	}

	if($('.pricing-block-no-paragraphs .content.mobile').length > 0) {
		$('.pricing-block-no-paragraphs .content.mobile').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			arrows: true,
			dots: true,
			autoplay: false,
			centerMode: false,
			variableWidth: false,
		});
	}

	$('.pricing-block-paragraphs .slick-next').html('<i class="fa-thin fa-arrow-right"></i>');
	$('.pricing-block-paragraphs .slick-prev').html('<i class="fa-thin fa-arrow-left"></i>');

	$('.pricing-block-no-paragraphs .slick-next').html('<i class="fa-thin fa-arrow-right"></i>');
	$('.pricing-block-no-paragraphs .slick-prev').html('<i class="fa-thin fa-arrow-left"></i>');

	$('.slick-dots button').html('');

	function treatmentsBlockHeight() {
		var maxHeight = 0;
		$('.treatments-block .treatment').each(function() {
			var height = $(this).outerHeight(); // Use outerHeight to include padding and borders
			if (height > maxHeight) {
				maxHeight = height;
			}
		});

		// Set the min-height of all .treatment elements to the maximum height
		$('.treatments-block .treatment').css('min-height', maxHeight + 'px');
	}

	treatmentsBlockHeight();

	setInterval(function () {
		treatmentsBlockHeight();
	}, 400);

	$(window).on('resize', function() {
		treatmentsBlockHeight();
	});

	if($('.partners-block').length > 0) {
		$('.partners-block .partners').slick({
			slidesToShow: 5,
			slidesToScroll: 1,
			infinite: true,
			arrows: false,
			dots: false,
			autoplay: true,
			centerMode: false,
			variableWidth: false,
			autoplaySpeed: 4000,
			responsive: [
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						infinite: true,
						arrows: false,
						dots: false,
						autoplay: false,
						centerMode: false,
						variableWidth: false,
					}
				}
			]
		});
	}

	if($('.before-block').length > 0) {
		$('.before-block .items').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			arrows: true,
			dots: false,
			autoplay: false,
			centerMode: false,
			variableWidth: false,
			responsive: [
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						infinite: true,
						arrows: true,
						dots: true,
						autoplay: false,
						centerMode: false,
						variableWidth: false,
					}
				}
			]
		});
	}

	if($('.videos-block .videos').length > 0) {
		$('.videos-block .videos').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			arrows: true,
			dots: false,
			autoplay: false,
			centerMode: false,
			variableWidth: false,
			responsive: [
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						infinite: true,
						arrows: false,
						dots: false,
						autoplay: true,
						centerMode: false,
						variableWidth: false,
						autoplaySpeed: 4000,
					}
				}
			]
		});
	}

	function feesBlocksMobile(container) {
		$(window).on('resize', function() {
			if ($(window).width() < 991) {
				setTimeout(function () {
					var maxHeight = 0;
					$(`${container} .item`).each(function () {
						var blockHeight = $(this).height();
						maxHeight = Math.max(maxHeight, blockHeight);
					});

					// Set the same height for all blocks
					$(`${container} .item`).height(maxHeight);
				}, 300)
			}
		});

		if ($(window).width() < 991) {
			setTimeout(function () {
				var maxHeight = 0;
				$(`${container} .item`).each(function () {
					var blockHeight = $(this).height();
					maxHeight = Math.max(maxHeight, blockHeight);
				});

				// Set the same height for all blocks
				$(`${container} .item`).height(maxHeight);
			}, 300)
		}
	}

	feesBlocksMobile('.fee-breakdowns-block .fee-breakdowns-top.mobile');
	feesBlocksMobile('.fee-breakdowns-block .fee-breakdowns-bottom.mobile');

	$('.fee-breakdowns-block .fee-breakdowns-top.mobile .slick-dots button').html('<span></span>');
	$('.fee-breakdowns-block .fee-breakdowns-bottom.mobile .slick-dots button').html('<span></span>');

	$('.videos-block .slick-prev').html('<p class="font-button button upper">Back</p>');
	$('.videos-block .slick-next').html('<p class="font-button button upper">Next</p>');

	if ($(window).width() < 991) {

		$('.before-block .slick-next').html('<i class="fa-thin fa-arrow-right"></i>');
		$('.before-block .slick-prev').html('<i class="fa-thin fa-arrow-left"></i>');

		$('.before-block  .slick-dots button').html('<span></span>');
		$('.before-block .slick-dots button').html('<span></span>');

	} else {

		$('.before-block .slick-prev').html('<p class="font-button button upper">Back</p>');
		$('.before-block .slick-next').html('<p class="font-button button upper">Next</p>');

	}

	$(window).on('resize', function() {
		$('.videos-block .slick-prev').html('<p class="font-button button upper">Back</p>');
		$('.videos-block .slick-next').html('<p class="font-button button upper">Next</p>');

		if ($(window).width() < 991) {
			if($('.fee-breakdowns-block .fee-breakdowns-top.mobile').length > 0) {
				$('.fee-breakdowns-block .fee-breakdowns-top.mobile').slick({
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						infinite: true,
						arrows: false,
						dots: true,
						autoplay: false,
						centerMode: false,
						variableWidth: false,
					},
					responsive: [
						{
							breakpoint: 9999,
							settings: "unslick"
						},
						{
							breakpoint: 991,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1,
								infinite: true,
								arrows: false,
								dots: true,
								autoplay: false,
								centerMode: false,
								variableWidth: false,
							}
						}
					]
				});
			}

			if($('.fee-breakdowns-block .fee-breakdowns-bottom.mobile').length > 0) {
				$('.fee-breakdowns-block .fee-breakdowns-bottom.mobile').slick({
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						infinite: true,
						arrows: false,
						dots: true,
						autoplay: false,
						centerMode: false,
						variableWidth: false,
					},
					responsive: [
						{
							breakpoint: 9999,
							settings: "unslick"
						},
						{
							breakpoint: 991,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1,
								infinite: true,
								arrows: false,
								dots: true,
								autoplay: false,
								centerMode: false,
								variableWidth: false,
							}
						}
					]
				});
			}

			$('.before-block .slick-next').html('<i class="fa-thin fa-arrow-right"></i>');
			$('.before-block .slick-prev').html('<i class="fa-thin fa-arrow-left"></i>');

		} else {
			$('.before-block .slick-prev').html('<p class="font-button button upper">Back</p>');
			$('.before-block .slick-next').html('<p class="font-button button upper">Next</p>');
		}

		$('.fee-breakdowns-block .fee-breakdowns-top.mobile .slick-dots button').html('<span></span>');
		$('.fee-breakdowns-block .fee-breakdowns-bottom.mobile .slick-dots button').html('<span></span>');

	});

	function changeImageOnMobile(container) {
		let imgForMobile = $(`${container}`).data('mobile');
		let imgForDesktop = $(`${container}`).data('desktop');


		if ($(window).width() < 991) {
			$(`${container}`).css('background-image', 'url(' + imgForMobile + ')');
		}
		else {
			$(`${container}`).css('background-image', 'url(' + imgForDesktop + ')');
		}

		$(window).on('resize', function() {
			if ($(window).width() < 991) {
				$(`${container}`).css('background-image', 'url(' + imgForMobile + ')');
			}
			else {
				$(`${container}`).css('background-image', 'url(' + imgForDesktop + ')');
			}
		});
	}

	changeImageOnMobile('.why-us-block .image')

	// $('.faq-block-mobile .accordion-button').on('click', function () {
	//
	// 	if($('.faq-block-mobile .accordion-button').hasClass('active')) {
	// 		$('.faq-block-mobile .accordion-button').removeClass('active');
	// 	}
	//
	// 	$(this).toggleClass('active');
	//
	// });

	$('.faq-block-mobile .accordion-button').on('click', function() {
		// Remove 'active' class from all menu buttons
		$('.faq-block-mobile .accordion-button .font-10').removeClass('active');

		// Add 'active' class to menu button of the clicked accordion item
		$(this).find('.font-10').addClass('active');
	});

	$('.covered-block-mobile .accordion-button').on('click', function() {
		// Remove 'active' class from all menu buttons
		$('.covered-block-mobile .accordion-button .font-10').removeClass('active');

		// Add 'active' class to menu button of the clicked accordion item
		$(this).find('.font-10').addClass('active');
	});

	$(".hero-contact .bottom #field_1_7 select").select2();

	$(".referral-form #field_3_4 select").select2();
	$(".referral-form #field_3_23 select").select2();

	$('.hero-contact .bottom .select2-selection__arrow').html('<i class="fa-sharp fa-solid fa-chevron-down"></i>');

	$('.referral-form .select2-selection__arrow').html('<i class="fa-sharp fa-solid fa-chevron-down"></i>');

	$('.hero-contact #field_1_8').after('<p class="font-3">Please show your teeth in the <span>biting</span> position with a nice <span>wide smile</span></p>');

	$('.hero-contact .gform_button').addClass('font-6 upper');

	$('.referral-form .gform_button').addClass('font-6 upper');

	$('.hero-contact #field_1_11 label').addClass('font-11 gold-text');
	$('.hero-contact #field_1_11 a').addClass('font-11 gold-text');

	$('.hero-contact #field_1_9 button').html('Choose photos');
	$('.hero-contact #field_1_10 button').html('Choose photo 2');

	$('.referral-form #field_3_22 button').html('Choose Files');

	$('.hero-contact .gform_footer input').on('click', function () {

		setTimeout(function () {
			$('.hero-contact #field_1_8').after('<p class="font-3">Please show your teeth in the <span>biting</span> position with a nice <span>wide smile</span></p>');
		}, 2000);
	});

	$('#locations-accordion-left .accordion-button').on('click', function() {
		// Remove 'active' class from all menu buttons
		$('.menu-button').removeClass('active');

		// Add 'active' class to menu button of the clicked accordion item
		$(this).find('.menu-button').addClass('active');
	});

	$('#locations-accordion-right .accordion-button').on('click', function() {
		// Remove 'active' class from all menu buttons
		$('.menu-button').removeClass('active');

		// Add 'active' class to menu button of the clicked accordion item
		$(this).find('.menu-button').addClass('active');
	});

	$('#accordionGallery .accordion-button').on('click', function() {
		// Remove 'active' class from all menu buttons
		$('#accordionGallery .accordion-button').removeClass('active');

		// Add 'active' class to menu button of the clicked accordion item
		$(this).addClass('active');
	});

	$('#accordion-careers .accordion-button').on('click', function() {
		// Remove 'active' class from all menu buttons
		$('#accordion-careers .accordion-button').removeClass('active');

		// Add 'active' class to menu button of the clicked accordion item
		$(this).addClass('active');
	});

	$('#accordion-careers .accordion-item').each(function() {
		var positionName = $(this).find('.accordion-header .accordion-button').text().trim(); // Get the position name

		// Find the input field in the corresponding Gravity Form and set its value to the position name
		$(this).find('.gform_wrapper #field_5_3 input').val(positionName);
	});

	$('#accordion-careers  #field_5_8 input').html('Upload CV');

	$('.future-opportunities  #field_6_7 button').html('Upload CV');

	var initialHeight = $('.team-section-big .font-8 p:first-of-type').height();
	function toggleTextHeight() {
		var textContainer = $('.team-section-big .content-wrapper');
		var currentHeight = textContainer.height();
		var maxHeight = $('.team-section-big .font-8').height();

		// Toggle between initial height and full height
		var newHeight = (currentHeight < maxHeight) ? maxHeight + 'px' : initialHeight + 'px';

		textContainer.css('max-height', newHeight);
	}

	if($('.team-section-big .font-8 p').length > 0) {
		$('.team-section-big .load').addClass('active');
		$('.team-section-big .content-wrapper').css('max-height', initialHeight);
	} else {
		$('.team-section-big .load').removeClass('active');
	}

	$('.team-section-big .load').on('click', (e) => {
		e.preventDefault();

		toggleTextHeight();

		if($('.team-section-big .font-8').hasClass('active')) {
			$('.team-section-big .font-8').removeClass('active');
			$('.team-section-big .load').html('Read full bio');
		} else {
			$('.team-section-big .font-8').addClass('active');
			$('.team-section-big .load').html('Read Less');
		}

	});

	$('.treatments-dropdown-wrapper select').on('select2:open', function (e) {
		$('.select2-dropdown.treatments-dropdown-class').addClass('fade-in');
	});

	$('.treatments-dropdown-wrapper select').on('select2:closing', function (e) {
		$('.select2-dropdown.treatments-dropdown-class').removeClass('fade-in');
	});

	function setEqualColumnHeight() {
		var tallestColumn = 0;
		var tallestColumn2 = 0;

		// Loop through each column
		$('.pricing-block-paragraphs .column .top').each(function() {
			var columnHeight = $(this).outerHeight();
			if (columnHeight > tallestColumn) {
				tallestColumn = columnHeight;
			}
		});

		$('.pricing-block-no-paragraphs .column .top').each(function() {
			var columnHeight = $(this).outerHeight();
			if (columnHeight > tallestColumn2) {
				tallestColumn2 = columnHeight;
			}
		});

		$('.pricing-block-no-paragraphs .column .top').css('height', tallestColumn2);
		$('.pricing-block-no-paragraphs .column .top').css('min-height', tallestColumn2);

		// Set the height of each column to match the tallest one
		$('.pricing-block-paragraphs .column .top').css('height', tallestColumn);
		$('.pricing-block-paragraphs .column .top').css('min-height', tallestColumn);
	}

	// Call the function initially
	setEqualColumnHeight();

	// Call the function again when the window is resized (optional)
	$(window).resize(function() {
		setEqualColumnHeight();
	});

	let wowNew = new WOW(
		{
			boxClass:     'wow',      // default
			animateClass: 'animated', // default
			offset:       0,          // default
			mobile:       true,       // default
			live:         true        // default
		}
	)
	wowNew.init();

});
